import { type TypedDocumentNode, gql } from '@apollo/client';

import { AddWatchlistToCartButton } from '../AddWatchlistToCartButton';
import { DestroyWatchlistButton } from '../DestroyWatchlistButton';
import { DumbWatchlistHeader } from '../DumbWatchlistHeader';
import { EditWatchlistButton } from '../EditWatchlistButton';
import { WatchlistMetas } from '../WatchlistMetas';
import type { WatchlistHeader_watchlist } from './__generated__/index.graphql';

type Props = {
  watchlist: WatchlistHeader_watchlist;
};

export const WatchlistHeader = ({ watchlist }: Props) => {
  const { commonPlayers, totalPlayersCount } = watchlist;
  const anyPlayers = commonPlayers?.nodes;
  const isEmpty = totalPlayersCount === 0;
  return (
    <DumbWatchlistHeader
      title={watchlist.title}
      playerUrls={anyPlayers.map(p => p.anyPlayer.fullPictureUrl)}
      actions={
        <>
          {!isEmpty && (
            <AddWatchlistToCartButton
              watchlist={watchlist}
              size="medium"
              color="quaternary"
              blur
            />
          )}
          <EditWatchlistButton
            size="medium"
            watchlist={watchlist}
            color="quaternary"
            blur
          />
          <DestroyWatchlistButton
            watchlist={watchlist}
            color="quaternary"
            size="medium"
            blur
          />
        </>
      }
      metas={<WatchlistMetas watchlist={watchlist} withCreatedAt />}
    />
  );
};

WatchlistHeader.fragments = {
  watchlist: gql`
    fragment WatchlistHeader_watchlist on Watchlist {
      id
      title
      totalPlayersCount
      commonPlayers(first: 7) {
        nodes {
          id
          anyPlayer {
            slug
            fullPictureUrl
          }
        }
      }
      ...WatchlistMetas_watchlist
      ...EditWatchlistButton_watchlist
      ...DestroyWatchlistButton_watchlist
      ...AddWatchlistToCartButton_watchlist
    }
    ${WatchlistMetas.fragments.watchlist}
    ${EditWatchlistButton.fragments.watchlist}
    ${DestroyWatchlistButton.fragments.watchlist}
    ${AddWatchlistToCartButton.fragments.watchlist}
  ` as TypedDocumentNode<WatchlistHeader_watchlist>,
};
